// extracted by mini-css-extract-plugin
module.exports = {"pinnedFooter":"XV7Ohcm7-bTOqb2i-vYuNg=="};